import { render } from "./WideHighlight.vue?vue&type=template&id=2e42e744&scoped=true"
import script from "./WideHighlight.vue?vue&type=script&lang=js"
export * from "./WideHighlight.vue?vue&type=script&lang=js"

import "./WideHighlight.vue?vue&type=style&index=0&id=2e42e744&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e42e744"]])

export default __exports__